<template>
    <v-container fluid>
        <v-row >
            <v-col>
                <h4 class="text-h4">Add New Item</h4>
                <p class="text-subtitle-1">New Item Creation Form</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        
        <v-row class="mt-1">
            <v-col>
                <ItemForm v-model="data" ref="form"/>
            </v-col>
        </v-row>
        <v-row >
            <v-col cols="12" md="3">
                <v-btn block color="primary" @click="handleSave">
                    <v-icon left>mdi-content-save</v-icon>
                    save
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import PAlert from '@/components/common/PAlert'
import { mapActions } from 'vuex';
import ItemForm from "./../../components/warehouse/ItemForm.vue";
import { v4 as uuid } from 'uuid';

export default {
    name: "ItemCreateView",
    components: {
        ItemForm,
        PAlert
    },  
    data() {
        return {
            idempotentKey: null,
            breadcrumbsItem: [
                { text: 'Warehouse & Inventory'},
                { text: 'Warehouse'},
                { text: 'Item' }
            ],
            data: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            }
        }
    },
    methods: {
        ...mapActions({
            create: "stock/item/create",
            snackbar: "ui/snackbar/show"
        }),
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.save};
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = false;
            this.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.snackbar({ text: "Item Created", color: "success" })
                this.$router.push({ name: "ItemDisplay", params: {id: response.data.id} })
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = true
            })
        },
    },
    created() {
        this.idempotentKey = uuid()
    },
}
</script>

<style>

</style>